import { render } from "./confirm.vue?vue&type=template&id=21217634&scoped=true&ts=true"
import script from "./confirm.vue?vue&type=script&lang=ts"
export * from "./confirm.vue?vue&type=script&lang=ts"

import "./confirm.vue?vue&type=style&index=0&id=21217634&scoped=true&lang=less"

import exportComponent from "/home/jenkins/agent/workspace/Project_moydom_master/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-21217634"]])

export default __exports__